import React, { useState } from 'react';
import { Box, CssBaseline, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { MenuOpen, Menu } from '@mui/icons-material';
import StudentSidebar from './StudentSidebar';

interface StudentLayoutProps {
  children: React.ReactNode;
}

const drawerWidth = 280;
const collapsedWidth = 80;

const StudentLayout: React.FC<StudentLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <CssBaseline />

      <StudentSidebar
        open={sidebarOpen}
        toggle={toggleSidebar}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)` },
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Top Bar */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <IconButton
            onClick={toggleSidebar}
            sx={{
              bgcolor: 'background.paper',
              boxShadow: 1,
              '&:hover': { bgcolor: 'background.paper', boxShadow: 3 }
            }}
          >
            {sidebarOpen ? <MenuOpen /> : <Menu />}
          </IconButton>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default StudentLayout;
